<template>
    <div class="admin">

        <div class="row">
			<div class="col s12 align-center u-p2">
				 <div v-if="loading">
		            <div class="spinner">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                    </div>
		            <h1>Please wait while we log you in</h1>
		        </div>
			</div>
      	</div>

    </div>
</template>

<script>

export default {
    name: 'admin',
    data : function () {
        return {
            loading     : true
        };
    },
    mounted : function () {
        let self = this;
        this.$root.setUserId(self.$route.params.id);
        setTimeout(function(){
            self.$root.logUserIn(self.$route.params.id)
        }, 2000);
    },
    components: {

    },
    computed : {

    },
    methods:{

    }
}
</script>
<style>


</style>